import React, { useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyButton = ({ value, ...others }) => {
  const [copyText, setCopyText] = useState("Copy");

  const handleClick = (e) => {
    e.stopPropagation();
    // Apply the provided filter function if available, else use the original value
    navigator.clipboard.writeText(value);
    setCopyText("Copied");
  };

  const handleMouseLeave = () => setCopyText("Copy");

  return (
    <Tooltip title={copyText} arrow>
      <IconButton size="small" onClick={handleClick} onMouseLeave={handleMouseLeave} {...others}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
